// extracted by mini-css-extract-plugin
module.exports = {"onHoldContainer":"membershipbadge_onHoldContainer__umqnP","obliqueLineWrap":"membershipbadge_obliqueLineWrap__2mHVL","obliqueLine":"membershipbadge_obliqueLine__1tWcH"};